import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";
import i18next from "i18next";
import AppUtil from "utilities/AppUtil";

const t = i18next.getFixedT();

const _urlPrefix = "/payroll";

export const reduceAddPayroll = createAsyncThunk(
  "payroll/reduceAddPayroll",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      data: snakecaseKeys(params),
      method: "POST",
      successMessage: t('toast.create.200')
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const reduceAddPayrollByWorkerList = createAsyncThunk(
  "payroll/reduceAddPayrollByWorkerList",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/create-payrolls-for-workers`,
      data: snakecaseKeys(params),
      method: "POST",
      successMessage: t('toast.create.200')
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchListPayroll = createAsyncThunk(
  "payroll/fetchListPayroll",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/page`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchPayrollDetail = createAsyncThunk(
  "payroll/fetchPayrollDetail",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/detail/${id}`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceSubmitPayroll = createAsyncThunk(
  "payroll/reduceSubmitPayroll",
  async (params) => {
    const { id, ...rest } = params
    const result = await httpRequest({
      url: `${_urlPrefix}/submit/${id}`,
      method: "PUT",
      data: snakecaseKeys(rest),
      successMessage: "toast.submit.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchPeriodTime = createAsyncThunk(
  "payroll/fetchPeriodTime",
  async () => {
    const result = await httpRequest({
      url: `${_urlPrefix}/period-time`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

const slice = createSlice({
  name: "payroll",
  initialState: {

  },
  reducers: {

  },
  extraReducers: {

  }
});

export default slice.reducer;
